import parseLinkHeader from 'parse-link-header';

import CallError from '../../../utils/CallError';
import fetchAndSetInSessionStorage from '../../../utils/fetchAndSetInSessionStorage';
import { rnrHeadEndpointSettings } from '../setup';

export default async (_params, signal = null) => {
  return await fetchAndSetInSessionStorage('rnrEndpoints', async () => {
    if (!rnrHeadEndpointSettings.endpoint) {
      throw new CallError('params', {}, 400, { message: 'Missing value for RNR HEAD endpoint' });
    }
    if (!rnrHeadEndpointSettings.apiKey) {
      throw new CallError('params', {}, 400, { message: 'Missing value for RNR HEAD api key' });
    }

    const response = await fetch(rnrHeadEndpointSettings.endpoint, {
      signal,
      method: 'HEAD',
      headers: {
        'x-api-key': rnrHeadEndpointSettings.apiKey,
      },
    });

    if (!response.ok) {
      throw new CallError('http', '', response.status, { message: response.statusText });
    } else {
      const parsedLinkHeader = parseLinkHeader(Object.fromEntries(response.headers).link);
      Object.keys(parsedLinkHeader).forEach((key) => {
        parsedLinkHeader[key] = parsedLinkHeader[key].url;
      });
      return parsedLinkHeader;
    }
  });
};
